import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_requestMemoInput} from "../../../function/FnBodySetting";
import {fn_request_memo_delete_layer} from "../../../function/FnBodyLayer";

@observer
class SettingDefaultRequestMemoCustomerView extends Component {

    constructor(props) {
        super(props);
        this.state={customerMemoValue:"", customerMemoFild:""}
    }

    componentWillUnmount() {
        this.setState({customerMemoFild:"", customerMemoValue:""});
    }

    customerList = (customerRequestMemoList) => {
        const { rootStore } = this.props;
        if (Array.isArray(customerRequestMemoList) && customerRequestMemoList.length > 0){
            return (
                <ul className="list_address">
                    {
                        customerRequestMemoList.map((obj, index)=>(
                            <li key={index}>
                                <strong>{obj.message}</strong>
                                <button className="btn_delete" onClick={e=>this.deleteMemo(obj)}><span>삭제</span></button>
                            </li>
                        ))
                    }
                </ul>
            )
        }else {
            return (
                <div className="box_self_delivery_none">
                    <div className="tit"><strong>등록된 메시지가 없어요</strong></div>
                    <p>자주 사용하는 주방요청 메시지를 등록해보세요.</p>
                </div>
            )
        }
    }

    validateCheck = customerMemoFild => {
        const { rootStore } = this.props;
        if (customerMemoFild.value.length <= 10) {
            this.setState({customerMemoFild:true, customerMemoValue:customerMemoFild.value});
        }
    }

    handleSubmit = (event) => {
        const { rootStore } = this.props;
        event.preventDefault();
        fn_requestMemoInput(rootStore, this.state.customerMemoValue)
        this.setState({customerMemoFild: "", customerMemoValue: ""});
    }

    deleteMemo = (obj) => {
        const { rootStore } = this.props;
        rootStore.settingStore.setRequestMemoDelete(obj)
        fn_request_memo_delete_layer(rootStore)
    }

    render() {
        const { rootStore } = this.props;
        const customerRequestMemoList = rootStore.settingStore.getCustomerRequestMemo;

        return(
            <div className="scroll tab">
                <div className="inner">
                    <div className="wrap_request">
                        <div className="box_tit">
                            <h4>고객요청 메시지 관리</h4>
                            <span>CID 주문등록 시, 고객요청사항 간편 입력 버튼 설정</span>
                        </div>
                        <div className="box_register">
                            <strong className="tit">고객요청 입력</strong>
                            <form name="manInfo" onSubmit={this.handleSubmit}>
                                <input type="text" className="inp_register" maxLength={10} placeholder="메시지를 입력해주세요." required
                                    value={this.state.customerMemoValue} onChange={e => this.validateCheck(e.target)}/>

                                <button type="submit" className="btn_register">등록</button>
                            </form>
                            <ul>
                                <li>배달전표에 출력될 고객요청 메시지를 등록해주세요</li>
                                <li>최대 한글 10자까지 입력 가능</li>
                            </ul>
                        </div>
                        {this.customerList(customerRequestMemoList)}
                    </div>
                </div>
            </div>
        )
    }
}

export default SettingDefaultRequestMemoCustomerView;